module.exports = __webpack_public_path__ + "img/03.08df9fd5.png";